import { AbstractControl } from '@angular/forms';


/**
 * A Validator that makes sure the value field contains 4 digits and
 * 4 digits only.
 *
 * @param {AbstractControl} control  The control to use this validator on.
 * @return {any} Null or an object with true to notify failure.
 * @constructor
 */
export function Validate4Digits(control: AbstractControl):any {

	// If the field is zero-length, this is OK.
	if (0 === control.value.length || 0 == control.value) {

		return null; // This means the test SUCCEEDED and the data are valid.

	}

	// If the field isn't zero-length, then it has to be 4 digits.
	let reg:RegExp = new RegExp('^\\d{4}$');

	if (! reg.test(control.value)) {

		return { valid4Digits: true }; // This means it FAILED the test and the data are invalid.

	}

	return null; // This means the test SUCCEEDED and the data are valid.

}


// WEBPACK FOOTER //
// ./src/app/validators/digits4.validator.ts